import { post } from './getpost.js'

const withAppId = (path, appId) => `${path}?app_id=${encodeURIComponent(appId || '')}`

export const createProductStockApply = params => {
    const { app_id, ...form } = params
    return post(withAppId('/teaching_studio_api/iotmax/stock_out_apply/add', app_id), form)
}

